// GlobalNotificationListener.js
import { useEffect } from "react";
import { getDatabase, ref, onChildAdded } from "firebase/database";

const GlobalNotificationListener = () => {
  useEffect(() => {
    const db = getDatabase();
    const types = [
      "Steel Orders",
      "New Query",
      "Negotiations",
      "Quotations",
      "Raised Issues",
      "Machinery Orders",
      "transportGoods",
      "Stop_Order",
      "Refund",
      "finance",
      "New Orders",
      "Document Verification",
      "Docs_Request",
    ];

    const unsubscribers = [];

    types.forEach((type) => {
      const typeRef = ref(db, `supplier_notifications/${type}`);

      const unsubscribe = onChildAdded(typeRef, (snapshot) => {
        const notification = snapshot.val();
        console.log("🔥 New notification:", type, notification);

        // System notification
        if (Notification.permission === "granted") {
          new Notification(`${type}`, {
            body: notification.message || "New notification received",
            icon: "/logo192.png", // optional app icon
          });
        } else {
          Notification.requestPermission();
        }
      });

      unsubscribers.push(() => unsubscribe());
    });

    return () => {
      unsubscribers.forEach((unsub) => unsub());
    };
  }, []);

  return null;
};

export default GlobalNotificationListener;
